import React from 'react';
import {
  Edit as EditIcon,
  Delete as DeleteIcon,
  Link as LinkIcon,
  OpenInNew as OpenInNewIcon,
  Star as StarIcon,
  StarBorder as StarBorderIcon,
} from '@mui/icons-material';
import { isActiveProduct } from '../../utils/productStatus';
import { getProductPublicUrl } from '../../utils/productPublicUrl';
import './ProductCard.css';

const ProductCard = ({
  product,
  onEdit,
  onDelete,
  isFeatured = false,
  featureToggleState = { visible: false, disabled: false, title: '' },
  onToggleFeatured,
}) => {
  const firstImage =
    product.media.photos && product.media.photos.length > 0 ? product.media.photos[0] : null;
  const storefrontUrl = isActiveProduct(product) ? getProductPublicUrl(product) : null;

  return (
    <div className={`product-card ${isFeatured ? 'product-card--featured' : ''}`}>
      <div className="product-image-container">
        {firstImage ? (
          <img
            src={firstImage.displayUrl || firstImage.url}
            alt={firstImage.alt || product.name}
            className="product-image"
          />
        ) : (
          <div className="product-image-placeholder">Pas d'image</div>
        )}
        {isFeatured && <span className="product-featured-badge">Mis en avant</span>}
        {storefrontUrl && (
          <a
            href={storefrontUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="product-storefront-link"
            title="Voir dans la boutique"
            aria-label="Voir dans la boutique"
          >
            <OpenInNewIcon fontSize="inherit" />
          </a>
        )}
      </div>

      <div className="product-card-header">
        <h3 className="product-name">{product.name}</h3>
        <span className="product-reference">{product.reference}</span>
      </div>

      <div className="product-card-body">
        <p className="product-description">{product.description}</p>
        <p className="product-price">
          {typeof product.price === 'number'
            ? `${product.price.toFixed(2)} €`
            : product.price
              ? `${product.price} €`
              : '0.00 €'}
        </p>

        {product.purchaseLinks?.[0]?.url || product.externalLink ? (
          <a
            href={product.purchaseLinks?.[0]?.url || product.externalLink}
            target="_blank"
            rel="noopener noreferrer"
            className="product-link"
          >
            <LinkIcon fontSize="small" /> Lien d&apos;achat
          </a>
        ) : null}
      </div>

      <div className="product-card-footer">
        {featureToggleState.visible && (
          <button
            type="button"
            className={`feature-btn ${isFeatured ? 'feature-btn--active' : ''} ${
              featureToggleState.disabled ? 'feature-btn--disabled' : ''
            }`}
            onClick={() => !featureToggleState.disabled && onToggleFeatured(product.id)}
            disabled={featureToggleState.disabled}
            title={featureToggleState.title}
          >
            {isFeatured ? (
              <>
                <StarIcon fontSize="small" /> Retirer
              </>
            ) : (
              <>
                <StarBorderIcon fontSize="small" /> Mettre en avant
              </>
            )}
          </button>
        )}
        <button className="edit-btn" onClick={() => onEdit(product.id)}>
          <EditIcon fontSize="small" /> Modifier
        </button>
        <button className="delete-btn" onClick={() => onDelete(product.id)}>
          <DeleteIcon fontSize="small" /> Supprimer
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
